<template>
  <div class="br-pricing-estimate__currency">
    <button
      v-for="currency in currencies"
      :key="currency.id"
      :class="{ 'button--active': model === currency.id }"
      class="button button--circle"
      @click.prevent="selectCurrency(currency)">
      <i
        :class="currency.className"
        class="icon"/>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    model: null,
    currencies: [{
      id: 1,
      code: 'USD',
      className: 'icon-currency-dollar'
    }, {
      id: 2,
      code: 'YEN',
      className: 'icon-currency-yen'
    }, {
      id: 3,
      code: 'EUR',
      className: 'icon-currency-euro'
    }, {
      id: 4,
      code: 'GBP',
      className: 'icon-currency-pound'
    }]
  }),
  created () {
    this.model = this.value
  },
  methods: {
    selectCurrency (currency) {
      this.model = currency.id
      this.$emit('input', currency.id)
    }
  }
}
</script>
